var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProcessingIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 14,
  fill: "none",
  viewBox: "0 0 15 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#494DCB",
  fillRule: "evenodd",
  d: "M3.661 1.145c.301-.197.693-.025.786.322a.6.6 0 0 1-.254.646 5.902 5.902 0 0 0 2.074 10.658l-.557-.706a.55.55 0 1 1 .864-.681l1.358 1.722a.55.55 0 0 1-.382.889.2.2 0 0 1-.05.005A7 7 0 0 1 3.661 1.145m7.16 10.733a.6.6 0 0 0-.253.645c.093.348.486.52.787.321A7 7 0 0 0 7.5 0a.2.2 0 0 0-.063.009.55.55 0 0 0-.37.887l1.358 1.722a.55.55 0 0 0 .864-.68l-.559-.71a5.902 5.902 0 0 1 2.09 10.65",
  clipRule: "evenodd"
})));
export { SvgProcessingIcon as ReactComponent };